import React from 'react';
import cn from 'classnames';

import { DEFAULT_STYLES } from '../../constants';
import { ComboBoxAddItemButtonProps } from '../../types/comboBoxComponentTypes';

import { ShadCNButton } from '../Button';

const AddIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 2.33333V11.6667M2.33333 7H11.6667"
      stroke="#4F46E5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ComboBoxAddItemButton: React.FC<ComboBoxAddItemButtonProps> = ({
  inputValue,
  buttonSize = 'md',
  buttonClassName,
  onButtonClick,
  variant = 'dropdown'
}) => (
  <div className={cn('flex-shrink-0 bg-white', variant === 'dropdown' ? 'p-4' : 'p-3')}>
    <ShadCNButton
      type="button"
      variant="outline"
      size={buttonSize}
      onClick={onButtonClick}
      fullWidth
      className={cn(
        variant === 'dropdown'
          ? DEFAULT_STYLES.combobox__dropdown__button
          : DEFAULT_STYLES.combobox__bottomSheet__button,
        buttonClassName
      )}
      leftElement={<AddIcon />}
    >
      {`Add New "${inputValue}"`}
    </ShadCNButton>
  </div>
);

ComboBoxAddItemButton.displayName = 'ComboBoxAddItemButton';
